import { Transaction } from '../../../domain/transaction';
import {useCallback, useEffect, useMemo, useState} from 'react';
import {DashboardTransacFiltersQueryParams} from './useDashboardTransactionFilters';
import {format} from "date-fns/format";
import {useTransactionsFilterByDateApi} from "./useTransactionsFilterByDateApi";

interface filterDates {
  startDate: Date
  endDate: Date
}

const useDashboardDonutFilterDate = (queryParamsDashboard: DashboardTransacFiltersQueryParams) => {

  const { results, queryParams,updateParams } = useTransactionsFilterByDateApi()

  const [transactions, setTransactions] = useState<Transaction[]>([])
  const [filterDate, setFilterDate] = useState<filterDates>()
  const transactionsByDate = useMemo(() => transactions, [transactions])

  useEffect(() => {
    setTransactions(results?.content || [])
  }, [results?.content]);

  useEffect(() => {
    if(filterDate && filterDate.startDate && filterDate.endDate) {
      queryParams.start = format(filterDate.startDate, 'yyyy-MM-dd')
      queryParams.end = format(filterDate.endDate, 'yyyy-MM-dd')
      queryParams.idBranch = queryParamsDashboard.idBranch
      queryParams.idMerchant = queryParamsDashboard.idMerchant

      updateParams(queryParams)
    }
  }, [queryParamsDashboard, filterDate]);

  const filterBy = useCallback((startDate: Date, endDate: Date) => {
    setFilterDate({startDate, endDate})
  }, [])

  return {
    filterBy,
    transactionsByDate
  }
}

export default useDashboardDonutFilterDate
